// i18n bootstrap: Nederlands, met de Engelse vertaling als naslag.

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import nl from './locales/nl/translation.json';
import en from './locales/en/translation.json';

const resources = {
    nl: { translation: nl },
    en: { translation: en },
};

// De app is Nederlandstalig; de taal volgt bewust niet de browserinstelling,
// zodat schermteksten en vaste teksten niet door elkaar gaan lopen.
i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'nl',
        fallbackLng: 'nl',
        supportedLngs: ['nl', 'en'],
        interpolation: { escapeValue: false },
    });

export default i18n;
